import { formatUsd } from "../../config/trading";

export function Watchlist({ tickers, selectedSymbol, onSelect }) {
  return (
    <aside className="panel side-panel" data-testid="watchlist-panel">
      <div className="panel-head">
        <span className="label">WATCHLIST</span>
        <span className="mono tiny" data-testid="ticker-source-label">{tickers?.[0]?.source?.toUpperCase()}</span>
      </div>
      <div className="watchlist">
        {tickers.map((ticker) => (
          <button
            key={ticker.inst_id}
            data-testid={`watchlist-${ticker.inst_id.toLowerCase().replace("-", "-")}-button`}
            className={selectedSymbol === ticker.inst_id ? "watch-row selected" : "watch-row"}
            onClick={() => onSelect(ticker.inst_id)}
          >
            <span>{ticker.inst_id}</span>
            <strong className="mono">{formatUsd(ticker.last)}</strong>
            <em className={ticker.change_24h >= 0 ? "positive" : "negative"}>{ticker.change_24h}%</em>
          </button>
        ))}
      </div>
    </aside>
  );
}